import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import * as Sentry from "@sentry/vue";

import App from './App.vue'
import LoginContents from './components/LoginScreen.vue'
import StartingDashboard from './components/StartDashboard.vue'
import FAQ from './components/FAQScreen.vue'
import UserProfile from './components/UserProfile.vue'
import DeviceReporting from './components/DeviceReporting.vue'
import DeviceList from './components/DeviceList.vue'
import DeviceDetails from './components/DeviceDetails.vue'

import RegisterIndividualDevice from './components/register/RegisterIndividualDevice.vue';
import RegisterIndividualUser from './components/register/RegisterIndividualUser.vue';
import EnrollDevice from './components/EnrollDevice.vue';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import 'bootstrap'

// Premium Yellow/White theme — ported from ctrlytics-main-frontend.
// Imported AFTER Bootstrap so our brand tokens/components win on collisions.
import './fonts/fonts.css'
import './assets/theme.css'
import './api/busyRetry' // global 503 server_busy banner + one auto-retry (Issue 36)
import './api/sessionGuard' // realtime sign-out when the account is signed in elsewhere

const app = createApp(App)
const router = createRouter({
    history: createWebHistory(),
    routes:[
        {
            path: '/',
            components:{
                default: LoginContents,
            },
            params: true,   
        },
        {
            path: '/enroll',
            component: EnrollDevice
        },
        {
            path: '/register/device',
            component: RegisterIndividualDevice
        },
        {
            path:'/register/user',
            component: RegisterIndividualUser
        },
        {
            path: '/dashboard',
            component: StartingDashboard,
        },
        {
            // POS accounts never manage accounts — redirect away from the admin-only page
            // (it 403s every call and leaves the app in a broken state if reached directly).
            path: '/manage-accounts',
            redirect: '/manage-devices',
        },
        {
            path: '/manage-devices',
            component: DeviceList
        },
        {
            path: '/device-data-list',
            component: DeviceDetails
        },
        {
            path: '/faq',
            component: FAQ,
        },
        {
            path: '/profile',
            component: UserProfile,
        },
        {
            path: '/reporting',
            component: DeviceReporting
        }
    ]
})
Sentry.init({
    app,
    dsn: "https://1dc91bf9ed1589cde427e56cb261d24f@o4505485535346688.ingest.us.sentry.io/4507490603106304",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

app.use(router).mount('#app')
